import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Mobile browsers fire a resize event when the address bar collapses/expands
// during scroll. invalidateOnRefresh recalculates the pin's start/end on any
// resize, so without this that mid-scroll resize jumps the pin position —
// the y-flicker right as it engages/disengages.
ScrollTrigger.config({ ignoreMobileResize: true });

const panels = [
  "I build digital experiences",
  "I care about the details",
  "Curiosity drives me",
  "Design sharpened my eye",
  "Systems changed how I think",
  "Graphics made software feel alive",
  "AI opened new possibilities",
  "I'm still exploring",
  ":)"
];

const Gallery = () => {
  const galleryBoxRef = useRef(null);
  const galleryOuterRef = useRef(null);

  useEffect(() => {
    const galleryBox = galleryBoxRef.current;
    const galleryOuter = galleryOuterRef.current;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: galleryBox,
        start: "center center",
        end: "+=2000",
        scrub: 1,
        pin: true,
        pinSpacing: false,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      },
    });

    tl.to(galleryOuter, { rotateY: -360, ease: "none", duration: 1 });

    const rafId = requestAnimationFrame(() => ScrollTrigger.refresh());

    return () => {
      cancelAnimationFrame(rafId);
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return (
    <section
      className="w-full h-[40vh] lg:h-[70vh] flex items-center justify-center [transform-style:preserve-3d] [transform:rotateX(-8deg)] pb-[80px] max-w-screen"
      ref={galleryBoxRef}
    >
      <div
        className="lg:w-[300px] lg:h-[200px] w-[200px] h-[150px] relative [transform-style:preserve-3d] [transform:perspective(1000px)]"
        ref={galleryOuterRef}
      >
        {panels.map((text, index) => (
          <div
            key={index}
            className="absolute flex items-center justify-center w-full h-full bg-center bg-cover rounded-xl cursor-pointer border border-[var(--home-primary)] lg:text-[24px] text-center text-[var(--home-primary)] font-milker lg:leading-[32px] group"
            style={{
              backgroundColor: "var(--home-bg)",
              transform: `rotateY(${index * 40}deg) translateZ(450px)`,
            }}
          >
            <p>
              {text}
              <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-0.5 bg-[var(--home-primary)]"></span>
            </p>
          </div>
        ))}
      </div>
      <img
        src="/images/mmm_coffee.svg"
        className="absolute top-0 lg:w-[500px] animate-float"
      />
    </section>
  );
};

export default Gallery;
